<section class="flex h-screen overflow-hidden bg-white">
  @if (popupMode()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/30 px-4">
    <article class="w-full max-w-lg overflow-hidden rounded-xl bg-white shadow-xl">
      @if (popupMode() === 'agreement') {
      <div class="flex items-center gap-2 bg-brand-primary px-5 py-3">
        <img [src]="imageEnum.INFO_WHITE" alt="info.svg" />
        <h2 class="secondary-label text-white font-inter font-semibold">Info</h2>
      </div>

      <div class="px-6 py-8 text-center sm:px-8">
        <p class="text-base font-normal leading-4 text-text-primary font-inter">
          Please accept the NON DISCLOSURE AGREEMENT before proceeding.
        </p>

        <div class="mt-7 flex justify-center">
          <app-outline-button text="OK" ariaLabel="Close info popup"
            buttonClass="h-10 min-w-18 rounded-md border-slate-400 px-6 text-base font-medium tracking-normal text-brand-primary transition hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-primary"
            (buttonClick)="closePopup()" />
        </div>
      </div>
      } @else if (popupMode() === 'system-check') {
      <div class="flex items-center justify-between bg-[#D32F2F] px-5 py-3">
        <h2 class="text-base font-bold text-white">Cannot Start Examination</h2>
        <button type="button" class="text-xl font-bold text-white transition hover:opacity-80"
          aria-label="Close system check popup" (click)="closePopup()">
          ×
        </button>
      </div>

      <div class="px-6 py-6 sm:px-8">
        <p class="text-base font-bold text-text-primary text-left">
          Please fix the following before starting the test:
        </p>
        <ul class="mt-3 list-disc pl-5 text-left">
          @for (issue of environmentIssues(); track issue) {
          <li class="mt-2 text-sm text-[#D32F2F]">{{ issue }}</li>
          }
        </ul>

        <hr class="my-6 border-slate-200" />

        <div class="flex w-full justify-center gap-4">
          <div class="w-1/2">
            <app-outline-button text="Exit Examination"
              buttonClass="w-full rounded-md !border-[#D32F2F] px-4 py-2.5 text-sm font-bold tracking-normal !text-[#D32F2F] hover:bg-red-50 active:bg-red-100"
              ariaLabel="Exit exam flow" (buttonClick)="exitToTestSeries()" />
          </div>
          <div class="w-1/2">
            <app-primary-button [text]="isCheckingEnvironment() || isStartingExam() ? 'Checking...' : 'Check Again'"
              buttonClass="w-full rounded-md px-4 py-2.5 text-sm font-bold tracking-normal !bg-[#3B5998] !bg-none hover:opacity-95 active:opacity-90 border-0 disabled:cursor-not-allowed disabled:opacity-60"
              ariaLabel="Check again" [disabled]="isCheckingEnvironment() || isStartingExam()"
              (buttonClick)="proceedToExam()" />
          </div>
        </div>
      </div>
      } @else {
      <div class="flex items-center justify-between bg-[#D32F2F] px-5 py-3">
        <h2 class="text-base font-bold text-white">Exit Examination</h2>
        <button type="button" class="text-xl font-bold text-white transition hover:opacity-80"
          aria-label="Close exit popup" (click)="resumeFullScreen()">
          ×
        </button>
      </div>

      <div class="px-6 py-6 sm:px-8">
        <p class="text-base font-bold text-text-primary text-left">
          Are you sure you want to exit the examination?
        </p>
        <p class="mt-2 text-sm text-[#D32F2F] text-left">
          Warning: Your progress is saved. You can resume this test later from the dashboard, but only within the total
          allotted time.
        </p>

        <hr class="my-6 border-slate-200" />

        <div class="flex w-full justify-center gap-4">
          <div class="w-1/2">
            <app-outline-button text="Exit Examination"
              buttonClass="w-full rounded-md !border-[#D32F2F] px-4 py-2.5 text-sm font-bold tracking-normal !text-[#D32F2F] hover:bg-red-50 active:bg-red-100"
              ariaLabel="Exit exam flow" (buttonClick)="exitToTestSeries()" />
          </div>
          <div class="w-1/2">
            <app-primary-button text="Stay in Examination"
              buttonClass="w-full rounded-md px-4 py-2.5 text-sm font-bold tracking-normal !bg-[#3B5998] !bg-none hover:opacity-95 active:opacity-90 border-0"
              ariaLabel="Stay in Examination" (buttonClick)="resumeFullScreen()" />
          </div>
        </div>
      </div>
      }
    </article>
  </div>
  }

  <div class="flex min-h-0 flex-1 flex-col xl:flex-row">
    <section class="flex min-h-0 flex-1 flex-col overflow-hidden border-r border-slate-200">
      <header class="bg-brand-primary px-3 py-1.5">
        <h1 class="text-base font-semibold text-white">Instructions</h1>
      </header>

      <div class="border-b border-slate-200 px-6 py-3">
        <p class="m-0 text-center text-xl font-normal leading-7 text-text-primary">
          Please read the instructions carefully
        </p>
      </div>

      <div #instructionsScroll class="instructions-scroll flex-1 overflow-y-auto px-12 pb-4 pt-2"
        (scroll)="onInstructionsScroll($event)">
        <section class="mb-6">
          <h2 class="instruction-section-title">General Instructions:</h2>

          <ol class="instruction-list mt-3 list-decimal">
            <li class="instruction-item text-mock-gray-800">
              Total duration of {{ examTitle() }} is {{ examDurationMinutes() }} minutes.
            </li>
            <li class="instruction-item text-mock-gray-800">
              The Question Palette displayed on the right side of screen will show the status of
              each question using one of the following symbols:
            </li>
          </ol>

          <div class="mt-4 flex flex-col gap-2 pl-5">
            @for (item of paletteLegend; track item.id) {
            <div class="instruction-legend-row">
              <span class="instruction-legend-tile">
                <span class="instruction-chip" [class.instruction-chip-default]="item.tone === 'slate'"
                  [class.instruction-chip-red]="item.tone === 'red'"
                  [class.instruction-chip-green]="item.tone === 'green'"
                  [class.instruction-chip-purple]="item.tone === 'purple'"
                  [class.instruction-chip-violet]="item.tone === 'violet'">
                  {{ item.count }}

                  @if (item.tone === 'violet') {
                  <span class="instruction-chip-dot" aria-hidden="true"></span>
                  }
                </span>
              </span>
              <p class="instruction-item m-0 text-mock-gray-800">{{ item.label }}</p>
            </div>
            }
          </div>

          <ol class="instruction-list mt-4 list-decimal" start="3">
            <li class="instruction-item text-mock-gray-800 mt-4">
              The Marked for Review status for a question simply indicates that you would like to
              look at that question again.
              <span class="instruction-red-text">
                If an answer is selected for a question that is Marked for Review, the answer will
                be considered in the final evaluation.
              </span>
            </li>
            <li class="instruction-item text-mock-gray-800">
              This test has {{ totalQuestions() }} questions carrying a maximum of
              {{ maximumMarks() }} marks.
            </li>
            <li class="instruction-item text-mock-gray-800">
              Each correct answer adds {{ correctAnswerMarks() }}
              {{ correctAnswerMarks() === 1 ? 'mark' : 'marks' }}.
              @if (wrongAnswerMarks()) {
              <span class="instruction-red-text">
                Each wrong answer deducts {{ wrongAnswerMarks() }}
                {{ wrongAnswerMarks() === 1 ? 'mark' : 'marks' }}.
              </span>
              } @else {
              There is no negative marking for wrong answers.
              }
            </li>
          </ol>
        </section>

        @for (section of sections(); track section.id) {
        <section class="mb-6">
          <h2 class="instruction-section-title">{{ section.title }}</h2>

          <ol class="instruction-list mt-3 list-decimal" [attr.start]="getSectionStart(section.id)">
            @for (item of section.items; track $index; let index = $index) {
            <li class="instruction-item text-mock-gray-800" [class.instruction-red-text]="
                    section.id === 'parts' || (section.id === 'answering' && index === 0)
                  " [class.text-text-secondary]="
                    section.id !== 'parts' && !(section.id === 'answering' && index === 0)
                  ">
              {{ item }}
            </li>
            }
          </ol>

          @if (section.id === 'parts' && examParts().length) {
          <div class="mt-4 overflow-x-auto pl-5">
            <table class="instruction-parts-table">
              <thead>
                <tr>
                  <th>Order</th>
                  <th>{{ hasConfiguredParts() ? 'Part' : 'Group' }}</th>
                  <th>Questions</th>
                  <th>Duration</th>
                </tr>
              </thead>
              <tbody>
                @for (part of examParts(); track part.id; let index = $index) {
                <tr>
                  <td>{{ index + 1 }}</td>
                  <td>{{ part.label }}</td>
                  <td>{{ getQuestionCount(part.info) }}</td>
                  <td>{{ part.durationInMinutes }} minutes</td>
                </tr>
                }
              </tbody>
            </table>
          </div>
          }
        </section>
        }

        <!-- Admin-authored instructions are extra points on top of the fixed defaults above. -->
        @if (apiInstructionsHtml(); as instructionsHtml) {
        <div class="api-instructions mb-6" [innerHTML]="instructionsHtml"></div>
        }

        <section id="nda-section" class="mb-2 p-2 rounded-lg transition-colors duration-500">
          <label class="flex items-start gap-3">
            <input type="checkbox"
              class="mt-1 h-4 w-4 rounded border-slate-300 text-brand-primary focus:ring-brand-primary"
              [checked]="hasAcceptedAgreement()" (change)="toggleAgreement($event)" />
            <div>
              <p class="m-0 text-xs font-semibold uppercase leading-5 text-text-primary">
                Non Disclosure Agreement
              </p>
              <p class="instruction-item mt-3 text-mock-gray-800">
                This test is confidential and proprietary. Charaka expressly prohibits you from
                disclosing, publishing, reproducing or transmitting this test, in whole or in group,
                in any form or by any means.
              </p>
              <p class="instruction-item mt-3 text-mock-gray-800">
                No content of this test must be shared with friends, acquaintances or third parties
                including sharing through online means or via social media. Social media includes
                but not limited to SMS, WhatsApp, Facebook, Twitter, Hangouts, Blogs etc.
              </p>
              <p class="instruction-item mt-3 text-mock-gray-800">
                Any violation of the same shall be liable for penal action as per the Charaka
                guidelines.
              </p>
            </div>
          </label>
        </section>
      </div>

      <div class="border-t border-slate-200 bg-white px-6 py-3">
        <div class="flex justify-end">
          <app-primary-button
            [text]="isCheckingEnvironment() ? 'Checking...' : isStartingExam() ? 'Starting...' : 'I am ready to begin'"
            ariaLabel="I am ready to begin"
            buttonClass="h-10 min-w-32 rounded-md px-6 text-xs font-semibold tracking-normal focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-primary disabled:cursor-not-allowed disabled:opacity-60"
            [disabled]="isStartingExam() || isCheckingEnvironment() || !hasScrolledToBottom()"
            (buttonClick)="proceedToExam()" />
        </div>
      </div>
    </section>

    <!-- <aside
      class="flex min-h-0 w-full max-w-full flex-col overflow-hidden bg-slate-50 xl:w-72 xl:max-w-72"
    >
      <div class="flex flex-1 flex-col items-center justify-start px-8 py-8">
        <div
          class="flex h-24 w-24 items-center justify-center rounded-sm bg-brand-primary text-5xl font-medium text-white"
        >
          {{ candidateInitial }}
        </div>

        <p class="mt-4 text-center text-2sm font-semibold leading-6 text-text-primary">
          Rishabh
          <br />
          Singh
        </p>
      </div>
    </aside> -->
  </div>
</section>